<template>
  <rv-input :disabled="disabled" :name="name" :label="label" :validation-rule="validationRule" :mask="mask" v-model="data" v-on:input="update" icon-pack="fas" icon="clock" :tooltip="tooltip"/>
</template>

<script>
import RvInput from './RvInput'

export default {
  props: ['name', 'value', 'label', 'validation-rule', 'disabled', 'tooltip'],
  inject: ['$validator'],
  components: { RvInput },
  data() {
    return {
      data: this.value,
      mask: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 3,
        numeralDecimalScale: 0,
        numeric: true
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  },
  watch: {
    value: function(val) {
      this.data = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/RvYear.vue